import React from 'react';
import PropTypes from 'prop-types';

import {Chip} from 'views/components';
import {translate} from 'views/module';

import contrast from 'css/Contrast';

const CaregiverStatusView = (props) => {
  const {
    caregiverData,
    setIsEditing,
  } = props;

  const status = caregiverData.status;

  const title = translate(`caregiver.Status.${status}.Title`);
  const color = translate(`caregiver.Status.${status}.Color`);
  const textColor = contrast(color);

  return (
    <Chip
      label={title}
      sx={{
        backgroundColor: color,
        color: textColor,
        cursor: 'pointer',
      }}
      onClick={() => setIsEditing(true)}
    />
  );
};

CaregiverStatusView.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(CaregiverStatusView);
